import TypePlugins from "./type/PluginSetup.js";
import RolloverPlugins from "./rollover/PluginSetup.js";
import SelectionPlugins from "./selection/PluginSetup.js";
import ItemPlugins from "./item/PluginSetup.js";
import DetailPlugins from "./shared/PluginSetup.js";
import CustomTextPlugins from "./customText/PluginSetup.js";
export default {
  install: opts => {
    DetailPlugins.install(opts);
    TypePlugins.install(opts);
    RolloverPlugins.install(opts);
    SelectionPlugins.install(opts);
    ItemPlugins.install(opts);
    CustomTextPlugins.install(opts);
  }
};